/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export * from './isEmail';
export * from './isMobile';
export * from './isValidLicensePlateNo';
